
// Define your action type
export const POST_USER_INFO = 'POST_USER_INFO';
export const CHAT_INFO = 'CHAT_INFO';

//get image

export const GET_IMAGE = 'GET_IMAGE';
export const GET_PDF = 'GET_PDF'

// get title

export const GET_TITLE = 'GET_TITLE';

// event
export const GET_EVENT = 'GET_EVENT';